import cn from "classnames";
import { isStartBidPoint, START_POINT_LETTER } from "helpers/bidpoint";
import { dateToView } from "helpers/date";
import {
    bidPointTypes,
    bidPointTypesEnum,
    gasStationTypesEnum,
    mapObjectTypes,
    mapObjectTypesEnum,
} from "helpers/enums";
import { clearGasStations } from "helpers/map";
import { enumLabel, pointLetter } from "helpers/system";
import React, { Component } from "react";

export default class RoutePanel extends Component {
    isDisabled = () => {
        const { activeElements, item } = this.props;
        const isActiveSegment =
            activeElements.segments && activeElements.segments.length && !activeElements.segments.includes(item.i);
        const isActivePoint = typeof activeElements.point === "number" && activeElements.point !== item.i;
        return item.panelType === "segment" ? isActiveSegment : isActivePoint;
    };

    centerMap = ({ location }) => {
        const { mergeVp, item } = this.props;
        if (location) {
            return mergeVp({ center: [...location.coordinates].reverse() });
        }
        return mergeVp({ center: [...item.geozone.location.coordinates].reverse() });
    };

    calcPointData = ({ type, geozone, panelType, i, customPointType, name }) => {
        const { elements } = this.props;
        const idFirstBidPoint = isStartBidPoint(elements[0].geozone.type) ? elements[1] : elements[0].i;
        const idLastBidPoint = elements[elements.length - 1].i;
        if (panelType === "bidpoint") {
            if (i === idLastBidPoint) {
                return { mod: "finish", label: "Конец маршрута" };
            } else if (i === idFirstBidPoint) {
                return { mod: "start", label: "Начало маршрута" };
            } else if (isStartBidPoint(geozone.type)) {
                return { mod: "start", label: enumLabel(mapObjectTypes, mapObjectTypesEnum.StartBidPoint) };
            } else if (type === bidPointTypesEnum.LoadPoint) {
                return { mod: "load", label: enumLabel(bidPointTypes, bidPointTypesEnum.LoadPoint) };
            } else if (type === bidPointTypesEnum.UnloadPoint) {
                return { mod: "unload", label: enumLabel(bidPointTypes, bidPointTypesEnum.UnloadPoint) };
            } else if (type === bidPointTypesEnum.CustomPoint) {
                return { mod: "custom", label: customPointType.name };
            } else if (type === 3) {
                return { mod: "loadunload", label: enumLabel(mapObjectTypes, mapObjectTypesEnum.BidPoint) };
            }
        } else if (panelType === "gasstation") {
            return {
                mod: "gasstation",
                label: `${enumLabel(mapObjectTypes, mapObjectTypesEnum.GasStation)} ${name || ""}`,
            };
        } else if (panelType === "itemchange") {
            return { mod: "itemchange", label: enumLabel(mapObjectTypes, mapObjectTypesEnum.ItemChangePoint) };
        } else if (panelType === "servicepoint") {
            return { mod: "servicepoint", label: enumLabel(mapObjectTypes, mapObjectTypesEnum.ServicePoint) };
        }
        return { mod: "geopoint", label: enumLabel(mapObjectTypes, mapObjectTypesEnum.RouteSupportPoint) };
    };

    handleSplit = () => {
        const { changeAe, item } = this.props;
        return changeAe({
            activeElements: { segments: [item.i] },
            sidebarOpened: false,
            mapClickDisabled: false,
            prevSegment: item,
        });
    };

    rejectSplit = () => {
        const { changeAe } = this.props;
        const activeElements = { point: null, segments: null };
        return changeAe({ activeElements, sidebarOpened: true, prevSegment: null, mapClickDisabled: true });
    };

    confirmNewGeopoint = () => {
        const { changeAe } = this.props;
        const activeElements = { point: null, segments: null };
        return changeAe({ activeElements, prevSegment: null });
    };

    rejectNewGeopoint = () => {
        const { prevSegment, elements, item, routeOptions } = this.props;
        return this.props
            .getRouteWithoutElement({ elements, item, routeOptions })
            .then((res) => this.props.calcDeleted({ ...res, prevSegment }));
    };

    deleteGeopoint = () => {
        const { item, routeOptions, prevSegment } = this.props;
        const { elements } = clearGasStations({ elements: this.props.elements });
        if (!this.props.isFetchingDelete) {
            this.props.setFetchingDelete(true);
            return this.props
                .getRouteWithoutElement({ elements, item, routeOptions })
                .then((res) => this.props.calcDeleted({ ...res, prevSegment }))
                .then(() => this.props.setFetchingDelete(false));
        }
    };

    renderSegment = () => {
        const { item, activeElements } = this.props;
        const { geozone, i } = item;
        return (
            <>
                <div className="map-panel__segment-body">
                    <div className="map-panel__segment-start link" onClick={() => this.centerMap(geozone.start)}>
                        {geozone.start.address}
                    </div>
                    <div className="map-panel__segment-end link" onClick={() => this.centerMap(geozone.end)}>
                        {geozone.end.address}
                    </div>
                </div>
                <div className="map-panel__actions">
                    {!activeElements.splitting ? (
                        activeElements.segments && activeElements.segments.includes(i) ? (
                            <div
                                className="map-panel__action map-panel__action--reject"
                                title="Отменить разделение"
                                onClick={this.rejectSplit}
                            />
                        ) : (
                            <div
                                className="map-panel__action map-panel__action--split"
                                title="Разделить участок"
                                onClick={this.handleSplit}
                            />
                        )
                    ) : null}
                </div>
            </>
        );
    };

    renderGeopointActions = () => {
        const { activeElements, item } = this.props;
        if (activeElements.point && activeElements.point === item.i) {
            return (
                <>
                    <div
                        className="map-panel__action map-panel__action--confirm"
                        title="Подтвердить разделение"
                        onClick={this.confirmNewGeopoint}
                    />

                    <div
                        className="map-panel__action map-panel__action--reject"
                        title="Отменить разделение"
                        onClick={this.rejectNewGeopoint}
                    />
                </>
            );
        } else if (item.panelType === "geopoint") {
            return (
                <div
                    className="map-panel__action map-panel__action--delete"
                    title="Удалить точку(маршрут будет перестроен)"
                    onClick={this.deleteGeopoint}
                />
            );
        }
        return null;
    };

    renderFuelIcon = () => {
        const { resource, gasStationType } = this.props.item;
        const className = cn("map-panel__refueling-icon", {
            "map-panel__refueling-icon--default":
                (!resource || !resource.iconUrl) && (!gasStationType || gasStationType === gasStationTypesEnum.Unknown),
        });

        let icon;
        if (resource && resource.iconUrl) {
            icon = (
                <img
                    src={resource.iconUrl}
                    className="b-timeline-point__circle--route-refueling-logo"
                    alt={resource.name || ""}
                />
            );
        } else if (gasStationType === gasStationTypesEnum.Rosneft) {
            icon = (
                <img
                    src="/images/refuelings/rosneft.png"
                    className="b-timeline-point__circle--route-refueling-logo"
                    alt="Роснефть"
                />
            );
        }

        return <div className={className}>{icon}</div>;
    };

    renderPointIcon = () => {
        const { item, index, firstLoadPointIndex } = this.props;
        const cname = cn("map-panel__route-icon", {
            "map-panel__route-icon--between": item.panelType === "geopoint",
            "map-panel__route-icon--itemchange": item.panelType === "itemchange",
            "map-panel__route-icon--servicepoint": item.panelType === "servicepoint",
        });
        const html = isStartBidPoint(item.geozone.type) ? START_POINT_LETTER : pointLetter(index, firstLoadPointIndex);

        return <div className={cname}>{item.panelType === "bidpoint" && html}</div>;
    };

    renderPoint = () => {
        const { item } = this.props;
        const { panelType, type, geozone, planEnterDateOffset, i, customPointType, name } = item;
        const { label } = this.calcPointData({ panelType, type, geozone, i, customPointType, name });
        return (
            <>
                <div className="map-panel__head">
                    {item.panelType === "gasstation" ? this.renderFuelIcon() : this.renderPointIcon()}
                    <div className="map-panel__head-title">{label}</div>
                </div>
                <div className="map-panel__point-body">
                    <div className="map-panel__point-address link" onClick={this.centerMap}>
                        {geozone.address}
                    </div>
                    <div className="map-panel__enter-date">
                        {panelType === "bidpoint" ? dateToView(planEnterDateOffset, "DD.MM.YYYY HH:mm (Z)") : ""}
                    </div>
                </div>
                <div className="map-panel__actions">{this.renderGeopointActions()}</div>
            </>
        );
    };

    render() {
        const { item } = this.props;
        const cname = cn("map-panel", { "map-panel--disabled": this.isDisabled() });
        return <div className={cname}>{item.panelType === "segment" ? this.renderSegment() : this.renderPoint()}</div>;
    }
}
